<template>
  <div>
    <div class="d-flex justify-content-between mb-4">
      <div>
        <div class="section-title">{{ $t("plannedschedule") }}</div>
      </div>
    </div>

    <div class="white-wrapper" style="margin-bottom: 25px">
      <div class="row">
        <div class="col-lg-4 col-xl-3 mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.cinema && selected.cinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :disabled="isRoleID"
              :text="selected.cinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.cinema && selected.cinema.length == 0"
              >{{ msgcinema }}</span
            >
          </p>
        </div>

        <div class="col-lg-2 col-xl-2 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.screen_name && selected.screen_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $tc("screen", 1) }}</label
            >
            <b-dropdown
              :text="selected.screen_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Screen"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchScreen()"
                  v-on:keydown="onSearchScreen()"
                  v-on:search="onSearchScreen()"
                  v-model="searchScreen"
                />
              </div>
              <b-dropdown-item
                v-for="(Screen, ScreenIndex) in ScreenList"
                @click="onSelectScreen($event, Screen, ScreenIndex)"
                :key="ScreenIndex"
                >{{ Screen.screen_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span
              v-if="
                submitted &&
                  selected.screen_name &&
                  selected.screen_name.length == 0
              "
              class="error_message"
              >{{ msgscreen }}</span
            >
          </p>
        </div>

        <div class="col-lg-2 col-xl-2 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="showdate"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="showdate"
                  name="showdate"
                  id="showdate"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <!-- {{showdate.length}} -->
                <label :class="typeof showdate === 'object' ? 'active' : ''">{{
                  $t("date")
                }}</label>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('showdate')">{{
                  errors.first("showdate")
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.movie_name && selected.movie_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $tc("movie", 1) }}</label
            >
            <b-dropdown
              :text="selected.movie_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Movie"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchMovie()"
                  v-on:keydown="onSearchMovie()"
                  v-on:search="onSearchMovie()"
                  v-model="searchMovie"
                />
              </div>
              <b-dropdown-item
                v-for="(movie, movieIndex) in MoviesList"
                @click="onSelectMovie($event, movie)"
                :key="movieIndex"
                >{{ movie.movie_name || movie.movie_title }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span
              v-if="
                submitted &&
                  selected.movie_name &&
                  selected.movie_name.length == 0
              "
              class="error_message"
              >{{ msgmovie }}</span
            >
          </p>
        </div>
        <div class="col-lg-2 col-xl-2 d-flex align-self-center mb-3">
          <button
            :disabled="btenable"
            @click.prevent.stop="Onfetch()"
            v-if="hasFieldsToFetch"
            class="btn-blue"
            style="min-width: 15px"
          >
            {{ $t("fetch") }}
          </button>
          <button
            @click.prevent.stop="OnClear()"
            class="btn-blue"
            v-if="hasFieldsToClear"
            style="min-width: 15px"
          >
            {{ $t("Clear") }}
          </button>
        </div>
      </div>

      <!-- <div class="row justify-content-center"></div> -->

      <div class="text-right mx-2 d-flex justify-content-end mt-2 mb-2">
        <!-- <div>
          <button
            :disabled="enable"
            class="btn-blue px-2"
            v-if="$can('update', 'Planned Schedule')"
            @click.prevent.stop="OpenModal()"
          >
            {{ $t("openall") }}
          </button>
        </div> -->
        <div>
          <button
            :disabled="enable"
            class="mr-2 btn border-0"
            v-if="$can('update', 'Planned Schedule')"
            @click.prevent.stop="OpenModal()"
            v-b-tooltip.hover="'Open All Schedule'"
            tabindex="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#8d6fbf"
              class="bi bi-calendar-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z"
              />
            </svg>
          </button>
        </div>

        <div v-if="$can('update', 'Planned Schedule')">
          <!-- <button
            :disabled="enable"
            v-if="selected_schedule.length == 0 || deleteindividual"
            @click.prevent.stop="changestatus('open')"
            class="btn-blue px-2"
          >
            {{ $t("openindividual") }}
          </button> -->
          <button
            :disabled="enable"
            v-if="selected_schedule.length == 0 || deleteindividual"
            @click.prevent.stop="changestatus('open')"
            class="mr-2 btn border-0"
            v-b-tooltip.hover="'Open Individual'"
            tabindex="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#8d6fbf"
              class="bi bi-calendar2-event-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM11.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
              />
            </svg>
          </button>

          <button
            v-if="selected_schedule.length > 0 && openindi === true"
            @click.prevent.stop="onfinalsubmit('Individual')"
            class="btn-blue px-2"
          >
            {{ $t("done") }}
          </button>
        </div>

        <div>
          <!-- <button
            :disabled="enable"
            v-if="
              (selected_schedule.length == 0 || openindi) &&
              $can('delete', 'Planned Schedule')
            "
            @click.prevent.stop="changestatus('delete')"
            class="btn-black px-2"
          >
            {{ $t("deleteindividual") }}
          </button> -->
          <button
            :disabled="enable"
            v-if="
              (selected_schedule.length == 0 || openindi) &&
                $can('delete', 'Planned Schedule')
            "
            @click.prevent.stop="changestatus('delete')"
            class="mr-2 btn border-0"
            v-b-tooltip.hover="'Delete Individual'"
            tabindex="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="red"
              class="bi bi-trash"
              viewBox="0 0 16 16"
            >
              <path
                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"
              />
              <path
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"
              />
            </svg>
          </button>

          <button
            v-if="selected_schedule.length > 0 && deleteindividual === true"
            @click.prevent.stop="onDeleteIndividual()"
            class="btn-black px-2"
          >
            {{ $t("done") }}
          </button>
        </div>

        <div
          v-if="PlannedScheduleList.length > 0"
          class="mt-2"
          v-b-tooltip.hover="'Download as Excel'"
          tabindex="0"
        >
          <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
          <!-- s             title="Download as Excel"-->

          <a target="_blank" @click="Onfetch('Y')" download>
            <img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="18"
              width="18"
            />
          </a>
        </div>

        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- Viewing&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>

      <table class="list-view-table">
        <thead style="text-align: start">
          <tr>
            <th>{{ $tc("cinema", 1) }}</th>
            <th>
              <span class="">
                <img
                  v-if="dateUpDown"
                  @click="onSortValue('date', (dateAscending = !dateAscending))"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="dateAscending"
                  @click="onSortValue('date', (dateAscending = !dateAscending))"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('date', (dateAscending = !dateAscending))"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $t("date") }}
              </span>
            </th>
            <th>{{ $t("showtime") }}</th>
            <th>{{ $tc("screen", 1) }}</th>
            <th>
              <span class="px-1">{{ $tc("movie", 1) }} </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, key) in PlannedScheduleList"
            :key="key"
            class="light_grey_back"
          >
            <td>{{ item.cine_name }}</td>
            <td style="text-align: left">
              {{ item.ss_start_date | dateparse }}
            </td>
            <td style="text-align: left; padding-right: 40px">
              {{ item.ss_start_date_time | TimeStamptoTime }}
            </td>
            <td style="text-align: left">
              {{ item.screen_name }}
            </td>
            <td>{{ item.movie || item.movie_title }}</td>

            <td class="text-left">
              <b-form-checkbox
                v-if="openindi"
                class="j-checkbox"
                :value="item"
                v-model="selected_schedule"
              />
              <b-form-checkbox
                v-if="deleteindividual"
                class="j-checkbox"
                :value="item"
                v-model="selected_schedule"
              />
            </td>
          </tr>
        </tbody>
        <tbody v-if="PlannedScheduleList.length === 0">
          <tr></tr>
          <tr>
            <td class="text-center" colspan="8">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal id="confirmation" title="Confirm" hide-footer no-close-on-backdrop>
      <label class="h4 mt-2 mb-4 text-center"
        >Are you sure you want to Open All Schedule ?</label
      >
      <br />
      <div class="text-center">
        <button
          :disabled="btenable"
          class="btn-blue"
          @click.prevent.stop="onfinalsubmit('All')"
        >
          Yes
        </button>
        <button
          class="btn-blue text-right"
          @click.prevent.stop="hideModal('confirmation')"
        >
          No
        </button>
      </div>
    </b-modal>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import scheduleService from "@/services/scheduleService";
  import CinemasService from "@/services/CinemasService";
  import MasterService from "@/services/MasterService";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        MoviesListCopy: [],
        searchMovie: "",
        ScreenListCopy: [],
        searchScreen: "",
        enable: false,
        btenable: false,
        openindi: false,
        deleteindividual: false,
        isRoleID: true,
        submitted: false,
        selected: {
          cinema: "",
          screen_name: "",
          movie_name: "",
          show_time: "",
        },
        selected_schedule: [],
        showdate: "",
        cineid: "",
        screenid: "",
        movieid: "",
        CinemasList: [],
        MoviesList: [],
        ScreenList: [],
        selectedMoviesInScreens: [],
        PlannedScheduleList: [],
        CinemasListCopy: [],
        searchCinema: "",
        dateAscending: true,
        dateUpDown: true,
        Flag: null,
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      this.isRoleID = false;
      this.getAllActiveCinemas(obj);

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.selected.cinema = CinemaObj.cine_name;
        this.cineid = CinemaObj.cine_id;
        this.getAllActiveScreens(CinemaObj.cine_id);
      }
      this.getAllActiveMovies();
      // this.Onfetch();
      this.getviewingnumber();
    },
    computed: {
      hasFieldsToFetch() {
        return (
          (this.selected.cinema && this.selected.cinema.length > 0) ||
          this.showdate ||
          this.selected.screen_name ||
          this.selected.screen_name.length > 0 ||
          this.selected.movie_name ||
          this.selected.movie_name.length > 0
        );
      },
      hasFieldsToClear() {
        return (
          this.selected.cinema ||
          this.showdate ||
          this.selected.screen_name ||
          this.selected.movie_name
        );
      },
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.Onfetch();
        } else {
          this.currentPage = event;
          this.Onfetch();
        }
      },
      onSearchMovie: function() {
        if (this.searchMovie && this.searchMovie.length > 0) {
          this.MoviesList = this.MoviesListCopy.filter((x) => {
            if (
              x.movie_title
                .toLowerCase()
                .includes(this.searchMovie.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.MoviesList = this.MoviesListCopy;
        }
      },
      onSearchScreen: function() {
        if (this.searchScreen && this.searchScreen.length > 0) {
          this.ScreenList = this.ScreenListCopy.filter((x) => {
            if (
              x.screen_name
                .toLowerCase()
                .includes(this.searchScreen.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.ScreenList = this.ScreenListCopy;
        }
      },
      onSortValue: function(column, ascending) {
        if (column == "date") {
          this.dateUpDown = false;
          if (ascending == false) {
            this.Flag = "DESC";
            this.Onfetch();
          } else {
            this.Flag = "ASC";
            this.Onfetch();
          }
        }
      },
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.CinemasList = this.CinemasListCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.CinemasList = this.CinemasListCopy;
        }
      },
      changestatus: function(change_to = "open") {
        this.selected_schedule = [];
        if (change_to === "open") {
          this.openindi = true;
          this.deleteindividual = false;
        } else if (change_to === "delete") {
          this.openindi = false;
          this.deleteindividual = true;
        }
      },
      OpenModal: function() {
        this.$bvModal.show("confirmation");
      },
      hideModal: function(modal) {
        if (modal == "confirmation") {
          this.$bvModal.hide("confirmation");
        }
      },
      clearSelectedDate: function() {
        this.showdate = "";
      },

      onSelectMovie: function(event, movie) {
        this.selected.movie_name =
          movie.movie_title + " " + movie.lang_name + " " + movie.mf_name;
        this.movieid = movie.md_id;
        this.dateenable = false;
        this.searchMovie = "";
        this.onSearchMovie();
      },

      onSelectScreen: function(event, screen, screenindex) {
        this.selected.screen_name = screen.screen_name;
        this.screenid = screen.screen_id;
      },

      onSelectCinema: function(event, cinema) {
        this.selected.cinema = cinema.cine_name;
        this.cineid = cinema.cine_id;
        this.getAllActiveScreens(cinema.cine_id);
        (this.searchCinema = ""), this.onSearchCinema(null);
        this.$store.dispatch("selectDropdownCinema", cinema);
      },

      getAllActiveCinemas: function(cine_id) {
        let payload = null;
        cine_id == null
          ? (payload = { tableName: "ms_cinemas", cine_is_active: "Y" })
          : (payload = {
              tableName: "ms_cinemas",
              cine_is_active: "Y",
              cine_id: cine_id,
            });
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasList = data.Records;
              this.CinemasListCopy = data.Records;
              this.CinemasList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.selected.cinema = x.cine_name;
                  let cinema = {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  };
                  this.onSelectCinema(event, cinema);
                }
              });
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },

      getAllActiveScreens: function(cinema_id) {
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            console.log("data :", data);
            if (data && data.status && data.Records.length > 0) {
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenListCopy = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenList.map((x) => {
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              });
            } else {
              // Show Message Here:
              this.$toasted.show(data.message);
              console.log("data.message :", data.message);
            }
          })
          .catch(this._CatchError);
      },

      getAllActiveMovies: function() {
        scheduleService
          .GetMovies()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult;
              this.MoviesListCopy = data.MovieListResult;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch(this._CatchError);
      },

      /* eslint-disable */
      goToRoute: function(path, item) {
        const { screen_id } = item;
        this.$router.push({
          path: path,
          query: {
            id: screen_id,
          },
        });
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },

      Onfetch: function(isExcel = "N") {
        this.PlannedScheduleList = [];
        let loader = this.$loading.show();

        let payload = {
          cinema_id: this.cineid,
          date: this.showdate,
          screen_id: this.screenid,
          movie_id: this.movieid,
          AscDescFlag: this.Flag, //For Ascending and Descending
          limit: this.perPage,
          currentPage: this.currentPage,
          isExcel,
        };
        this.btenable = true;

        CinemasService.listplannedschedule(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              this.PlannedScheduleList = data.Records;
              if (data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }

              if (this.PlannedScheduleList.length == 0) {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
                this.$toasted.show(data.message);
                this.enable = true;
              } else {
                this.enable = false;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },

      OnClear: function() {
        this.selected_schedule = [];
        this.openindi = false;
        this.selected = {
          cinema: "",
          screen_name: "",
          movie_name: "",
          show_time: "",
        };

        this.showdate = "";
        this.cineid = "";
        this.screenid = "";
        this.movieid = "";

        this.Onfetch();
      },

      onfinalsubmit: function(flag) {
        let loader = this.$loading.show();

        let payload;
        this.btenable = true;
        if (flag == "All") {
          payload = {
            scheduleList: this.PlannedScheduleList,
          };
        }
        if (flag == "Individual") {
          payload = {
            scheduleList: this.selected_schedule,
          };
        }

        CinemasService.updateplannedschedule(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              this.selected_schedule = [];
              this.openindi = false;
              this.selected = {
                cinema: "",
                screen_name: "",
                movie_name: "",
                show_time: "",
              };

              this.showdate = "";
              this.cineid = "";
              this.screenid = "";
              this.movieid = "";

              this.$bvModal.hide("confirmation");

              this.$toasted.show(data.message);
              this.Onfetch();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },

      onDeleteIndividual: function() {
        let loader = this.$loading.show();

        let payload = {
          scheduleList: this.selected_schedule,
        };

        CinemasService.deletePlannedSchedule(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              this.clearForm();
              this.$bvModal.hide("confirmation");
              this.$toasted.show(data.message);
              this.Onfetch();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      clearForm() {
        this.selected_schedule = [];
        this.openindi = false;
        this.deleteindividual = false;
        this.selected = {
          cinema: "",
          screen_name: "",
          movie_name: "",
          show_time: "",
        };

        this.showdate = "";
        this.cineid = "";
        this.screenid = "";
        this.movieid = "";
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/PlannedScheduleComponents/listplannedschedule.vue